import anime from 'animejs/lib/anime.es.js';

/**
 * Transition the height of an element
 * - replicates the jQuery slideToggle() method
 * 
 * @param {Element} target 
 * @param {String} toggleClass 
 * @param {Element} toggleEl 
 */
const toggleHeight = (
  target = false, 
  targetClass = false, 
  toggleEl = false,
  toggleClass = false
) => {
  if (target && targetClass && toggleEl) {
    if (!target.classList.contains(targetClass)) {
      toggleEl.style.display = 'block'
      let offsetHeight = toggleEl.offsetHeight
      toggleEl.style.display = 'none'

      toggleEl.style.height = 0
      toggleEl.style.display = 'block'

      anime({
        targets: toggleEl,
        height: offsetHeight,
        duration: 300,
        easing: 'cubicBezier(.5, .05, .1, .3)'
      })
    } else {
      anime({
        targets: toggleEl,
        height: 0,
        duration: 300,
        easing: 'cubicBezier(.5, .05, .1, .3)',
        complete: (anim) => {
          toggleEl.style.display = 'none'
          toggleEl.style.removeProperty('height')
        }
      })
    }
    target.classList.toggle(targetClass)

    if (toggleClass) toggleEl.classList.toggle(toggleClass);
  } else {
    console.warn('Toggle Height: Missing parameters')
  }
}

export { toggleHeight }